<div class="filter-container mb-4 flex flex-col gap-2">
  <div class="grid grid-cols-3 gap-6 py-2 pt-4">
    <app-filter-item-search
      [label]="isArabic() ? 'البحث باسم العرض' : 'Offer Name'"
      [(searchTerm)]="searchTerm"
      [placeholder]="isArabic() ? 'البحث باسم العرض' : 'Search by offer name...'" />

    <app-filter-multi-select
      [label]="{ titleAr: 'الحالة', titleEn: 'Status' }"
      [items]="options()"
      [(selectedIds)]="selectedStatuses"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="showStatusDropdown.set(!showStatusDropdown())"
      (selectionChange)="onStatusesChange($event)" />

    <app-filter-multi-select
      [label]="{ titleAr: 'نوع العرض', titleEn: 'Offer Type' }"
      [items]="offerTypes()"
      [(selectedIds)]="selectedOfferTypes"
      [showDropdown]="showOfferTypeDropdown()"
      (toggleDropdown)="showOfferTypeDropdown.set(!showOfferTypeDropdown())"
      (selectionChange)="onOfferTypesChange($event)" />

    <app-filter-date-component [label]="isArabic() ? 'بدأ في من' : 'Started On From'" [(value)]="startedOnFrom" />
    <app-filter-date-component
      [label]="isArabic() ? 'بدأ في إلى' : 'Started On To'"
      [(value)]="startedOnTo"
      [isInvalid]="startedOnInvalid()" />
    <div></div>
    <app-filter-date-component [label]="isArabic() ? 'ينتهي في من' : 'Ended On From'" [(value)]="endedOnFrom" />
    <app-filter-date-component
      [label]="isArabic() ? 'ينتهي في إلى' : 'Ended On To'"
      [(value)]="endedOnTo"
      [isInvalid]="endedOnInvalid()" />
  </div>
  <div class="mt-4 flex justify-between border-t border-gray-200 pt-4">
    <div class="flex flex-col gap-1.5 pt-4">
      <div class="group relative max-w-[275px]">
        <label
          for="orderBy"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminProductsSortBy">
          Sort By
        </label>
        <div class="flex gap-2">
          <div class="relative w-full">
            <select
              name="orderBy"
              id="orderBy"
              class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10"
              (change)="changeOrderBy($event)">
              <option value="TITLE" i18n="@@offerName">Offer Name</option>
              <option value="START_DATE" i18n="@@startDate">Start Date</option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black transition-colors group-focus-within:text-black group-hover:text-gray-800 ltr:right-3 rtl:left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <button
            (click)="toggleOrderDir()"
            class="w-[150px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
            @if (filters()?.orderDir === "DESC") {
              <span i18n="@@adminCategoriesSortAsc">ASC</span>
            } @else {
              <span i18n="@@adminCategoriesSortDesc">DESC</span>
            }
          </button>
        </div>
      </div>
    </div>
    <div class="col-span-2 flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="outlineButton rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="primaryButton rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button>
    </div>
  </div>
</div>
